module.exports = __webpack_public_path__ + "static/media/signoutwhite.0111fff5.svg";